export default "__VITE_ASSET__0e72ed46__"